import { MessageBox } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';

const messages = defineMessages({
  title: {
    id: 'core.notFound.title',
    defaultMessage: 'Page not found',
  },
  description: {
    id: 'core.notFound.description',
    defaultMessage: 'Page at this address does not exist.',
  },
  submit: {
    id: 'core.notFound.submit',
    defaultMessage: 'To main page',
  },
});

const useStyles = createUseStyles({
  container: {
    minWidth: '200px',
  },
});

const NotFound = (): React.JSX.Element => {
  const intl = useIntl();
  const classes = useStyles();
  const navigate = useNavigate();

  const onSubmit = () => {
    void navigate('/');
  };

  return (
    <MessageBox
      className={classes.container}
      onClose={onSubmit}
      open
      title={intl.formatMessage(messages.title)}
    >
      <MessageBox.Content>
        <div className="m-pa-lg">
          {intl.formatMessage(messages.description)}
        </div>
      </MessageBox.Content>
      <MessageBox.Footer>
        <MessageBox.Button
          type="submit"
          label={intl.formatMessage(messages.submit)}
          onClick={onSubmit}
        />
      </MessageBox.Footer>
    </MessageBox>
  );
};

export default NotFound;
